import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  AfterViewInit,
  Renderer2,
  OnInit,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastType } from '@shared/enum/toast-type';
import { Policy } from '@modules/hotel-booking/models/hotel-result.model';
import { IProperty } from '@modules/hotel-booking/models/hotel-search.model';
import { createSlug } from '@shared/utils/helper';
import { ActivatedRoute, Router } from '@angular/router';
import { BookMarkService } from '@modules/hotel-booking/services/bookmark/bookmark.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QuickViewHotelPhotoModal } from '../quick-view-hotel-photo/quick-view-hotel-photo.component';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/core/services/user/user.service';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipPosition, TooltipTheme } from '@shared/enum/tooltip.enums';
import { SearchService } from '@modules/hotel-booking/services/search/search.service';
import { PlaceType } from '@shared/enum/recommend-place.enum';
import { SearchBarService } from '@modules/hotel-booking/services/search-bar.service';
import { AmenitiesService } from 'src/app/services/amenities.service';
import { HotelDetailsService } from '@modules/hotel-booking/services/hotel-detail/hotel-detail.service';
import { BadgeService } from 'src/app/services/badge.service';
import { AccommodationType } from '@shared/enum/accommodation-type';

@Component({
  selector: 'app-hotel-result-card',
  templateUrl: './hotel-result-card.component.html',
  providers: [MessageService, TranslateModule],
  styleUrls: ['./hotel-result-card.component.scss'],
})
export class HotelResultCardComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tagLine1') tagLine1: ElementRef;
  @ViewChild('tagLine2') tagLine2: ElementRef;
  @ViewChild('facilityTemplate') facilityTemplate: ElementRef;
  @ViewChild('ratingTemplate') ratingTemplate: ElementRef;
  @ViewChild('containerPrice') containerPrice: ElementRef;
  @ViewChild('badgeContainer', { static: false }) badgeContainer!: ElementRef;
  @ViewChild('tag') listContainer: ElementRef;
  @ViewChild('policy', { static: true }) listPolicy: ElementRef;
  @ViewChildren('hotelPolicy') hotelPolicyElements: QueryList<ElementRef>;
  @ViewChildren('hotelName') hotelNameElements: QueryList<ElementRef>;
  @ViewChildren('hotelfacility') hotelFacilityElements: QueryList<ElementRef>;
  @ViewChildren('hotelAddress') hotelAddressElements: QueryList<ElementRef>;
  @ViewChildren('hotelDistance') hotelDistanceElements: QueryList<ElementRef>;
  @Input() index: number;
  @Input() item: IProperty;
  @Input() currentPage: number;
  @Input() isLoading: boolean;
  @Input() numOfPropertiesAPI2: number;
  @Input() isGetPrice: boolean;
  @Input() isMainItem: boolean = false;

  TooltipPosition: typeof TooltipPosition = TooltipPosition;
  TooltipTheme: typeof TooltipTheme = TooltipTheme;
  showTooltip: boolean = false;

  h1Element: HTMLElement | null = null;
  elementWidth: number = 0;
  elementHeight: number = 0;

  isMouse: any;

  ngUnsubscribe = new Subject<void>();
  hotelPolicyArray: any;
  hotelFacilityArray: any;
  hotelNameArray: any;
  hotelAddressArray: any;
  hotelDistanceArray: any;

  remainingFacility: string;
  hasRemainingFacility: boolean = false;
  numberOverFacility: number;
  isTooltipFacility: boolean;
  remainingPolicy: number | string;
  hasRemainingPolicy: boolean = false;
  isPrice: boolean = false;
  sliceFacility: string;
  slicePolicy: string;

  resizeTimeout: any;
  itemTagFacility: number[] = [];
  itemTagPolicy: number[] = [];
  displayFacility1: any[] = [];
  displayFacility2: any[] = [];
  displayPolicy: Policy[] = [];

  showScoreTooltip = false;
  showStarTooltip = false;
  ref: DynamicDialogRef | undefined;
  listImages: string[] = [];
  baseUrl = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;
  baseImageId = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;

  isLogin: boolean | null;
  isBookmarked: boolean;

  resizeTimer: any;
  isLoadingPriceCache: boolean;

  amenitiesTranslated: any[] = [];

  placeAdress: string;
  isDragging = false;
  startX = 0;
  scrollLeft = 0;

  displayBadges: any = [];
  showAmenitiesPopup: boolean = false;

  room = [
    AccommodationType.LOVE_HOTEL,
    AccommodationType.LODGE,
    AccommodationType.MOTEL,
    AccommodationType.HOSTEL,
    AccommodationType.HOMESTAY,
    AccommodationType.HOTEL,
    AccommodationType.RESORT,
    AccommodationType.INN,
    AccommodationType.GUEST_HOUSE,
    AccommodationType.GLAMPING,
    AccommodationType.FARM_STAY,
    AccommodationType.OTHERS
  ];
  
  entireHome = [
    AccommodationType.APARTMENT,
    AccommodationType.ENTIRE_HOME,
    AccommodationType.COUNTRY_HOUSE,
    AccommodationType.CONDOTEL,
    AccommodationType.VACATION_HOME,
    AccommodationType.HOLIDAY_PARK,
    AccommodationType.VILLA,
    AccommodationType.CRUISE
  ];
  roomName: string = '';
  bedNames: string[] = [];

  constructor(
    private searchBarService: SearchBarService,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private bookMarkService: BookMarkService,
    public dialogService: DialogService,
    private userService: UserService,
    private translateService: TranslateService,
    private searchService: SearchService,
    private amenitiesService: AmenitiesService,
    private hotelDetailsService: HotelDetailsService,
    private badgeService: BadgeService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.translateAmenities();
    this.checkIsLogin();
    this.item.room_amenity_list.filter((item: any) => {
      if (item.amenity_name === 'Spa') {
        item.amenity_icon = 'Spa';
      }
    });
    this.calculatePolicy();
    this.checkBookmark();
    this.searchService
      .isLoadingPrice()
      .subscribe((isLoading) => (this.isLoadingPriceCache = isLoading));

    this.translateService.onLangChange.subscribe(() => {
      this.translateAmenities();
      this.updateDataViewFacility();
    });
    if(this.item.badges && this.item.badges.length > 0) {
      const shuffledBadges = this.shuffleArray(this.item.badges || []);
      this.displayBadges = this.getBadgeData(shuffledBadges, this.item.origin_price, this.item.net_price);
      this.translateService.onLangChange.subscribe(async (event: LangChangeEvent) => {
        this.displayBadges = this.getBadgeData(shuffledBadges);
        this.bedNames = this.buildTooltipTextBedName(); 
        await this.transalteRoomView(this.item);
        this.roomName = this.buildTooltipTextRoomName();
      });
    }
    this.bedNames = this.buildTooltipTextBedName();
    await this.transalteRoomView(this.item);
    this.roomName = this.buildTooltipTextRoomName();
  }

  promotions = [
    { image_url: 'assets/images/promotion1.png' },
    { image_url: 'assets/images/promotion2.png' },
    { image_url: 'assets/images/promotion3.png' },
    { image_url: 'assets/images/promotion4.png' },
  ];

  async transalteRoomView(item: any) {
    if(item.room_info?.view?.room_view_name) {
      const room_view_translate = await this.amenitiesService.getValueByKey(item.room_info.view.room_view_name.trim(), item.resource_id || 0)
      item.room_info.view.room_view_translate = room_view_translate;
    } 
  }

  startDrag(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.pageX - this.badgeContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.badgeContainer.nativeElement.scrollLeft;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.badgeContainer.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 1; // tốc độ kéo
    this.badgeContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  stopDrag() {
    this.isDragging = false;
  }

  getShortPropertyName(name: string): string {
    const isMobile = window.innerWidth < 768; // breakpoint md theo Tailwind
    const maxWords = isMobile ? 5 : 8;

    const words = name?.split(' ') || [];
    if (words.length <= maxWords) return name;

    return words.slice(0, maxWords).join(' ') + '...';
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && this.item) {
      this.searchBarService.getQueryParamData().subscribe((res: any) => {
        if (res && res.dest_type == PlaceType.PLACES.toUpperCase() && res.city_name) {
          this.placeAdress = res.city_name;
        } else {
          this.placeAdress = '';
        }
        this.item.rental_night = this.countDay(res.checkin, res.checkout);
      });
    }
  }

  async translateAmenities() {
    try {
      this.amenitiesTranslated = (
        await Promise.all(
          this.item.room_amenity_list?.map(
            async (item: { amenity_key: string }) => ({
              ...item,
              amenity_translated: await this.amenitiesService.getValueByKey(
                item.amenity_key,
                this.item.resource_id
              ),
            })
          )
        )
      ).filter((item) => item.amenity_translated);
    } catch (error) {
      this.amenitiesTranslated = [];
    }
    this.displayFacility1 = [...this.amenitiesTranslated];
    this.displayFacility2 = [...this.amenitiesTranslated];
  }

  ngAfterViewInit(): void {
    this.responsivePrice();
    this.updateDataViewFacility();
    // this.calculateSumItem(this.itemTagFacility, this.listContainer);
    // this.calculateSumItem(this.itemTagPolicy, this.listPolicy);
    // this.updateViewFacility(2);
    // this.updateViewPolicy(1);
    // this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getShortAddress(addr: string): string {
  const isMobile = window.innerWidth < 768; // breakpoint md của Tailwind
  const maxWords = isMobile ? 10 : 7;

  const words = addr?.split(' ') || [];
  return words.length > maxWords ? words.slice(0, maxWords).join(' ') + '…' : addr;
}

  translateBadgeName(badge: string): string {
    const key = badge.toLowerCase().replace(/ /g, '_');

    switch (key) {
      case 'top_booked_nearby':
        return 'DETAIL.BADGE.TOP_BOOKED_NEARBY';
      case 'selling_fast':
        return 'DETAIL.BADGE.SELLING_FAST';
      case 'most_popular_hotel_nearby':
        return 'DETAIL.BADGE.MOST_POPULAR_HOTEL_NEARBY';
      case 'highly_rated':
        return 'DETAIL.BADGE.HIGHLY_RATED';
      case 'exclusive_deal':
        return 'DETAIL.BADGE.EXCLUSIVE_DEAL';
      case 'trending_now':
        return 'DETAIL.BADGE.TRENDING_NOW';
      case 'recommended':
        return 'DETAIL.BADGE.RECOMMENDED';
      case 'special_discount':
        return 'DETAIL.BADGE.SPECIAL_DISCOUNT';
      case 'hot_deal':
        return 'DETAIL.BADGE.HOT_DEAL';
      case 'featured':
        return 'DETAIL.BADGE.FEATURED';
      default:
        return 'DETAIL.BADGE.UNKNOWN_BADGE';
    }
  }

  getBadgeStyle(badge: string) {
    switch (badge.toLowerCase()) {
      // Pink
      case 'top booked nearby':
      case 'selling fast':
        return {
          'background-color': '#FFF1F3',
          color: '#F63D68',
          'border-color': '#EAECF0',
          iconUrl: 'assets/icons/Solid__stars-01.svg',
        };
      // Blue 2 star
      case 'most popular hotel nearby':
        return {
          'background-color': '#EFF8FF',
          color: '#2E90FA',
          'border-color': '#B2DDFF',
          iconClass: 'sctr-icon-solid-star-06',
        };
      // Orange 1 star
      case 'highly rated':
        return {
          'background-color': '#FEF6EE',
          color: '#EF6820',
          'border-color': '#F9DBAF',
          iconClass: 'sctr-icon-solid-star-01',
        };
      // Blue 1 star
      case 'exclusive deal':
      case 'trending now':
      case 'recommended':
        return {
          'background-color': '#EFF8FF',
          color: '#2E90FA',
          'border-color': '#B2DDFF',
          iconClass: 'sctr-icon-solid-star-01',
        };
      // Violet
      case 'special discount':
      case 'hot deal':
      case 'featured':
        return {
          'background-color': '#F5F3FF',
          color: '#875BF7',
          'border-color': '#DDD6FE',
          iconClass: 'sctr-icon-solid-tag-01',
        };
      default:
        return {
          'background-color': '#FFF1F3',
          color: '#F63D68',
          'border-color': '#EAECF0',
          iconClass: 'sctr-icon-solid-zap',
        };
    }
  }

  initData = {
    badges: [
      'Top Booked Nearby',
      'Most Popular Hotel Nearby',
      'Highly Rated',
      'Selling Fast',
      'Exclusive Deal',
      'Special discount',
      'Hot Deal',
      'Featured',
      'Trending Now',
      'Recommended',
    ],
  };

  shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  checkIsLogin() {
    this.userService.getLoginStatus().subscribe((isLogin) => {
      this.isLogin = isLogin;
    });
  }

  checkBookmark() {
    this.bookMarkService.isBookmarkExists(this.item.property_id).subscribe({
      next: (isBookmarked) => {
        this.isBookmarked = isBookmarked;
      },
    });
  }

  calculatePolicy() {
    if (this.item.is_free_breakfast) {
      this.displayPolicy.push({
        name: this.translateService.instant('SEARCH_RESULT.FREE_BREAKFAST'),
        type: 'warning',
      });
    }
    if (this.item.is_free_cancellation) {
      this.displayPolicy.push({
        name: this.translateService.instant('SEARCH_RESULT.FREE_CANCELLATION'),
        type: 'success',
      });
    }
    if (!this.item.is_prepayment_required) {
      this.displayPolicy.push({
        name: this.translateService.instant(
          'SEARCH_RESULT.NO_PREPAYMENT_REQUIRED'
        ),
        type: 'error',
      });
    }
    // this.displayPolicy.push(
    //   {
    //     name: 'Breakfast',
    //     type: 'warning',
    //   },
    //   {
    //     name: 'Free cancellation',
    //     type: 'success',
    //   },
    //   {
    //     name: 'No prepayment required',
    //     type: 'error',
    //   }
    // )
  }

  calculateSumItem(itemTag: number[], el: ElementRef) {
    const frameTag = el.nativeElement;
    const tags = frameTag.children;
    let sumSizeTag = 0;
    for (let index = 0; index < tags.length; index++) {
      const tag = tags[index];
      if (tag.nodeType === Node.ELEMENT_NODE) {
        const childElement = tag as HTMLElement;
        sumSizeTag += childElement.offsetWidth;
        itemTag.push(sumSizeTag);
      }
    }
  }

  handleBookmark(event: any) {
    event.stopPropagation();
    if (!this.isLogin) {
      this.messageService.add({
        key: 'hd',
        severity: ToastType.WARNING,
        detail: 'Please login before bookmark',
      });
      return;
    }
    if (this.isBookmarked) {
      this.bookMarkService.removeBookMark(this.item.property_id).subscribe({
        next: (response) => {
          if (response.success) {
            this.isBookmarked = false;
            this.bookMarkService.getBloomFilter();
            this.messageService.add({
              key: 'rsc',
              severity: ToastType.SUCCESS,
              detail: this.translateService.instant('BOOKMARK.DELETE'),
            });
          }
        },
      });
    } else {
      this.bookMarkService.addBookMark(this.item.property_id).subscribe({
        next: (response) => {
          if (response.success) {
            this.isBookmarked = true;
            this.bookMarkService.getBloomFilter();
            this.messageService.add({
              key: 'rsc',
              severity: ToastType.SUCCESS,
              detail: this.translateService.instant('BOOKMARK.ADD'),
            });
          }
        },
      });
    }
  }

  responsivePrice() {
    if (
      (window.innerWidth <= 1560 && window.innerWidth >= 1280) ||
      (window.innerWidth <= 1080 && window.innerWidth >= 768) ||
      (window.innerWidth <= 768 && window.innerWidth >= 0)
    ) {
      this.isPrice = true;
    } else this.isPrice = false;
    this.cdRef.detectChanges();
  }

  getPropertyImageId(item: IProperty) {
    return item.property_image_ids
      ? `${this.baseUrl}/${item?.property_image_ids[0]}.webp`
      : 'assets/images/temporary/default-hotel.png';
  }

  showAllFacility(): void {
    this.displayFacility1 = [...this.amenitiesTranslated];
  }

  showAllPolicy(): void {
    this.displayPolicy = [];
  }

  onSignIn() {
    window.location.href = environment.SOCIAL_APP_URL + '/login?r=' + encodeURIComponent(window.location.href);
  }

  removeDuplicates(a: any, b: any) {
    let setA = new Set(a);
    b = b.filter((item: any) => !setA.has(item));
    return b;
  }

  updateDataViewFacility() {
    // Delay để đảm bảo DOM đã render xong trước khi đo offsetWidth
    setTimeout(() => {
      // Tính chiều rộng tối đa có thể dùng để hiển thị tiện ích
      const widthfacilityTemplate = this.facilityTemplate?.nativeElement.offsetWidth; // khung tổng chứa tiện ích
      const ratingTemplate = this.ratingTemplate?.nativeElement.offsetWidth || 20;   // phần tử chiếm không gian (vd: điểm đánh giá)
      const widthFacility = widthfacilityTemplate - ratingTemplate; // phần còn lại dành cho tiện ích
  
      // DÒNG 1: Hiển thị các tiện ích đến khi hết chỗ
      const frameTag1 = this.tagLine1?.nativeElement;
      const tags1 = frameTag1?.children;
      let sumSizeTag = 0;
  
      for (let index = 0; index < tags1?.length; index++) {
        const tag = tags1[index];
        if (tag.nodeType === Node.ELEMENT_NODE) {
          const childElement = tag as HTMLElement;
          sumSizeTag += childElement.offsetWidth;
  
          // Nếu tiện ích vượt quá chiều rộng hiển thị → cắt sang dòng 2
          if (sumSizeTag > widthFacility) {
            this.displayFacility1 = [...this.amenitiesTranslated.slice(0, index)];
            this.displayFacility2 = [...this.amenitiesTranslated.slice(index)];
            sumSizeTag = 0; // reset để dùng tiếp cho dòng 2
            break;
          }
        }
      }
  
      // Nếu chỉ có 1 tiện ích hoặc không đủ dài để chia, không cần xử lý tiếp
      if (this.amenitiesTranslated.length < 2) {
        this.displayFacility2 = [];
        return;
      }
  
      // DÒNG 2: Tiếp tục hiển thị phần còn lại nếu còn chỗ
      const frameTag2 = this.tagLine2?.nativeElement;
      const tags2 = frameTag2?.children;
  
      for (let index = 0; index < tags2?.length; index++) {
        const tag = tags2[index];
        if (tag.nodeType === Node.ELEMENT_NODE) {
          const childElement = tag as HTMLElement;
          sumSizeTag += childElement.offsetWidth;
  
          // Nếu dòng 2 bị tràn (chừa khoảng 100px để không sát mép)
          if (sumSizeTag > widthFacility - 150) {
            const temp = [...this.displayFacility2];
            this.displayFacility2 = [...temp.slice(0, index)];
  
            // Nếu có phần dư không hiển thị được → gom lại
            if (temp.length !== this.displayFacility2.length) {
              this.hasRemainingFacility = true;
              this.remainingFacility = temp
                .slice(index)
                .map((item) => item.amenity_translated)
                .join(', ');
              this.numberOverFacility = temp.slice(index).length;
            } else {
              // Không có phần dư
              this.remainingFacility = '';
              this.hasRemainingFacility = false;
            }
  
            sumSizeTag = 0;
            break;
          }
        }
      }
  
      // Loại bỏ tiện ích trùng giữa dòng 1 và dòng 2 (nếu có)
      this.displayFacility2 = this.removeDuplicates(
        this.displayFacility1,
        this.displayFacility2
      );
    }, 100);
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.responsivePrice();
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(() => {
      this.displayFacility1 = [...this.amenitiesTranslated];
      this.displayFacility2 = [...this.amenitiesTranslated];
      this.updateDataViewFacility();
    }, 250);
  }

  handleShowTooltip(els: ElementRef[], className: string): void {
    for (var val of els) {
      const isTruncated =
        val.nativeElement.scrollWidth > val.nativeElement.clientWidth;
      if (isTruncated) {
        this.renderer.addClass(val.nativeElement, className);
      } else {
        this.renderer.removeClass(val.nativeElement, className);
      }
    }
  }

  onMouseTooltipFacility(e: MouseEvent) {
    const x = e.clientX + window.scrollX;
    const y = e.clientY + window.scrollY;
    const html = `
      <div class="bg-[#475467] relative rounded-lg text-white py-2 px-4 font-semibold text-xs shadow-lg opacity-1 z-[6] max-w-xs">
        ${this.remainingFacility}
      </div>
    `;
    if (!this.h1Element) {
      this.h1Element = document.createElement('div');
      this.h1Element.innerHTML = html;
      this.h1Element.style.position = 'absolute';
      document.body.appendChild(this.h1Element);
      this.elementWidth = this.h1Element.offsetWidth;
      this.elementHeight = this.h1Element.offsetHeight;
    }
    this.h1Element.style.left = x - this.elementWidth + 'px';
    this.h1Element.style.top = y - this.elementHeight + 'px';
  }

  onMouseLeaveTooltipFacility() {
    if (this.h1Element && this.h1Element.parentNode) {
      this.h1Element.parentNode.removeChild(this.h1Element);
      this.h1Element = null;
    }
  }

  onShowAmenities() {
    this.showAmenitiesPopup = true;
  }

  onHideAmenities() {
    this.showAmenitiesPopup = false;
  }

  mouseOverHotelDistance() {
    this.hotelDistanceArray = this.hotelDistanceElements.toArray();
    this.handleShowTooltip(this.hotelDistanceArray, 'hotel-distance');
  }

  getAmenityTooltip(amenities: any[]): string {
    return amenities.map((a) => a.amenity_translated).join(', ');
  }

  handleClickView(event: Event) {
    event.stopPropagation();
    this.messageService.add({
      severity: ToastType.WARNING,
      detail: 'This feature is not developed yet',
    });
  }

  convertDoubleToInt(num: any) {
    return num | 0;
  }

  formatCurrency(price: number) {
    return price?.toLocaleString('en-US');
  }

  genRouterLink(id: string, name: string, city_name: string) {
    const addressArray = city_name.split(',');
    let cityNameSlug = createSlug(addressArray[addressArray.length - 1]);
    if (cityNameSlug == '' || !cityNameSlug) {
      cityNameSlug = 'property';
    }
    let hotelNameSlug = createSlug(name);
    if (hotelNameSlug == '' || !hotelNameSlug) {
      hotelNameSlug = 'hotel-name';
    }
    return `/booking/hotel/search/${cityNameSlug}/${hotelNameSlug}`;
  }

  genQueryParams(id: string, name: string, address: string) {
    const queryParams = { ...this.route.snapshot.queryParams, property_id: id };
    return queryParams;
  }

  cacheHotel(hotel: any) {
    if (this.hotelDetailsService.getCacheHotel(hotel.property_id)) return;
    const cacheHotel = hotel;
    cacheHotel.property_amenity_list =
      hotel.room_amenity_list || hotel.property_amenity_list;
    this.hotelDetailsService.setCacheHotel(hotel.property_id, cacheHotel);
  }

  viewMap(item: IProperty) {
    const genQueryParams = this.genQueryParams(
      item.property_id,
      item.property_name,
      item.city_name
    );
    this.router.navigate(['/booking/hotel/map', this.item.property_name], {
      queryParams: {
        ...genQueryParams,
        dest_type: PlaceType.PROPERTY.toUpperCase(),
      },
    });
  }

  convertImgIdsToImages(images: string[]) {
    return images.map((image) => this.baseUrl + '/' + image + '.webp');
  }

  checkHover() {
    this.isMouse = true;
  }

  showImg(e: Event) {
    e.stopPropagation();
  }

  quickViewPhotos(event: Event, images: string[]) {
    event.stopPropagation();
    this.ref = this.dialogService.open(QuickViewHotelPhotoModal, {
      data: {
        selectedImage: images,
      },
      showHeader: false,
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      dismissableMask: true,
    });
    this.ref.onClose.subscribe((data: any) => { });
    this.ref.onMaximize.subscribe((value: any) => { });
  }

  checkImageList(property_image_urls: any, property_image_ids: any) {
    if (property_image_ids.length < 1 || property_image_ids == null) {
      return property_image_urls;
    } else {
      return this.convertImgIdsToImages(property_image_ids);
    }
  }

  replaceWithDefaultImage(event: any): void {
    event.target.src = 'assets/images/temporary/default-hotel.png';
  }

  countDay(check_in: string, check_out: string): number {
    const checkin = new Date(check_in);
    const checkout = new Date(check_out);

    const checkinTimestamp = checkin.getTime();
    const checkoutTimestamp = checkout.getTime();

    const millisecondsInDay = 1000 * 60 * 60 * 24;
    const daysDifference = Math.floor(
      (checkoutTimestamp - checkinTimestamp) / millisecondsInDay
    );

    return daysDifference;
  }

  getBadgeData(badgeCodes: string[], originPrice: number = 0, netPrice: number = 0) {
    if (!badgeCodes) return [];

    const styleMap: { [key: string]: any } = {
      'TOP_BOOK_NEARBY': {
        bgColor: '#FFF1F3',
        color: '#F63D68',
        borderColor: '#EAECF0',
        iconUrl: 'assets/icons/Solid__stars-01.svg',
      },
      'SELL_FAST': {
        bgColor: '#FFF1F3',
        color: '#F63D68',
        borderColor: '#EAECF0',
        iconUrl: 'assets/icons/Solid__stars-01.svg',
      },
      'POPULAR_NEARBY': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-06',
      },
      'HIGH_RATE': {
        bgColor: '#FEF6EE',
        color: '#EF6820',
        borderColor: '#F9DBAF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'EXCLUSIVE_DEAL': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'TRENDING_NOW': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'RECOMMEND': {
        bgColor: '#EFF8FF',
        color: '#2E90FA',
        borderColor: '#B2DDFF',
        iconClass: 'sctr-icon-solid-star-01',
      },
      'SPECIAL_DISCOUNT': {
        bgColor: '#F5F3FF',
        color: '#875BF7',
        borderColor: '#DDD6FE',
        iconClass: 'sctr-icon-solid-tag-01',
      },
      'HOT_DEAL': {
        bgColor: '#F5F3FF',
        color: '#875BF7',
        borderColor: '#DDD6FE',
        iconClass: 'sctr-icon-solid-tag-01',
      },
      'FEATURE': {
        bgColor: '#F5F3FF',
        color: '#875BF7',
        borderColor: '#DDD6FE',
        iconClass: 'sctr-icon-solid-tag-01',
      },
    };
    
    return badgeCodes.map((badgeCode: any) => {
      const label = this.badgeService.getBadgeLabel(badgeCode, originPrice, netPrice);
      if (!label) return null;
  
      const style = styleMap[badgeCode] || {
        bgColor: '#FFF1F3',
        color: '#F63D68',
        borderColor: '#EAECF0',
        iconClass: 'sctr-icon-solid-zap',
      };
  
      return {
        label,
        badgeCode,
        ...style
      };
    }).filter(Boolean);
  }

  buildTooltipTextRoomName(): string {
    if (!this.item.room_info)
      return '';
    const name = this.item.room_info.room_name || '';
    const capacity = this.item.room_info.capacity;
    const adultLabel = capacity > 1 ? this.translateService.instant('COMMON.ADULT', { syntax: 's' }) : this.translateService.instant('COMMON.ADULT', { syntax: '' });
    const view = this.item.room_info.view?.room_view_translate || '';
    
    let tooltip = name;
    if (capacity && capacity > 0) {
        tooltip += ` ${capacity} ${adultLabel}`;
    }
    tooltip += ` ${view}`;
    
    return tooltip.trim();
  }

  buildTooltipTextBedName(): string[] {
    if (!this.item.room_info) 
      return []
    const beddingArray = this.item.room_info.bedding || [];
    const numOfBedrooms = this.item.room_info.num_of_bedroom;
    const propertyType = this.getPropertyType(this.item.room_info.room_type_name);

    // Initialize an array to store formatted bed strings
    const bedStrings: string[] = [];

    // Case 1: Process each bedding item in the array
    if (beddingArray.length > 0) {
      beddingArray.forEach((bedding: {
        capacity: any; num_of_beds: any; bed_type: null; 
          }) => {
        const numOfBeds = bedding?.num_of_beds;
        const bedType = bedding?.bed_type || null;
        const capacity = bedding?.capacity;

        let bedString = '';

        // Handle bed information when bed_type is available
        if (bedType) {
          const bedLabel = this.translateService.instant('COMMON.BED_TYPE', { syntax: numOfBeds > 1 ? 's' : '', bed_type : bedType });
          // Include num_of_beds if it's a positive number
          if (numOfBeds && numOfBeds > 0) {
            bedString += `${numOfBeds} ${bedLabel}`;
          } else {
            bedString += `${bedLabel}`;
          }

          // Append capacity if it's a positive number
          if (capacity && capacity > 0) {
              const adultLabel = this.translateService.instant('COMMON.ADULT', { syntax: capacity > 1  ? 's' : '' });
              bedString += ` ${capacity} ${adultLabel}`;
          }

          bedStrings.push(bedString.trim());
        }
      });
    }

    // Case 2: No bedding array or empty, but num_of_bedroom is available
    if (bedStrings.length === 0 && numOfBedrooms && numOfBedrooms > 0) {
      const bedroomLabel = this.translateService.instant('COMMON.BED_ROOM', { syntax:  numOfBedrooms > 1  ? 's' : '' });
      bedStrings.push(`${propertyType} ${numOfBedrooms} ${bedroomLabel}`);
    }

    // Case 3: No valid bedding info and no bedrooms, return empty array
    return bedStrings;
  }

  getPropertyType(property_type: string): string {
    switch (property_type) {
      case AccommodationType.LOVE_HOTEL:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.LOVE_HOTEL');
      case AccommodationType.MOTEL:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.MOTEL');
      case AccommodationType.HOSTEL:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.HOSTEL');
      case AccommodationType.HOTEL:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.HOTEL');
      case 'House': // không có trong enum nhưng có trong JSON
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.HOUSE');
      case AccommodationType.ENTIRE_HOME:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.ENTIRE_HOME');
      case AccommodationType.COUNTRY_HOUSE:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.COUNTRY_HOUSE');
      case AccommodationType.CONDOTEL:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.CONDOTEL');
      case AccommodationType.VACATION_HOME:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.VACATION_HOME');
      case AccommodationType.HOLIDAY_PARK:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.HOLIDAY_PARK');
      case AccommodationType.HOMESTAY:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.HOMESTAY');
      case AccommodationType.RESORT:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.RESORT');
      case AccommodationType.VILLA:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.VILLA');
      case AccommodationType.GUEST_HOUSE:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.GUEST_HOUSE');
      case AccommodationType.APARTMENT:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.APARTMENT');
      case AccommodationType.CRUISE:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.CRUISE');
      case AccommodationType.LODGE:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.LODGE');
      case AccommodationType.FARM_STAY:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.FARM_STAY');
      case AccommodationType.INN:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.INN');
      case AccommodationType.GLAMPING:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.GLAMPING');
      case AccommodationType.OTHERS:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.PROPERTY');
      default:
        return this.translateService.instant('ACCOMMODATION_CATEGORY_TYPE.PROPERTY');
    }
  }
}
